module.exports = __webpack_public_path__ + "static/media/ENGLong1w1042@1x.73775454.jpg";